export default __webpack_public_path__ + "static/media/madlibs.93915883.jpg";